import { createFileRoute } from "@tanstack/react-router";
import { LegalDocumentPage } from "@/components/LegalDocumentPage";

export const Route = createFileRoute("/terms")({
  component: () => <LegalDocumentPage slug="terms" fallbackTitle="Terms of Service" />,
  head: () => ({
    meta: [
      { title: "Terms of Service - Inquira" },
      { name: "description", content: "Terms and conditions for using Inquira." },
      { property: "og:title", content: "Terms of Service - Inquira" },
      { property: "og:description", content: "Terms and conditions for using Inquira." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
});